import React from "react";
import {useTheme} from "@mui/material/styles";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Grid from "@mui/material/Grid";
import {useTranslation} from "react-i18next";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Button from "@mui/material/Button";


export default function DatasetAbortWarning(props) {

    const theme = useTheme();
    // init internationalization
    const {t} = useTranslation();

    return (
        <Grid
            id="dataset-abortUpload-container"
            container
            spacing={2}
            sx={{padding: theme.spacing(5, 1),}}

        >
            <Alert severity="warning" className="abortUploadWarning"
                   icon={<WarningAmberIcon fontSize="large" sx={{alignItems: "center"}}/>}>
                <AlertTitle>{t("common.Warning")}</AlertTitle>
                {t("datasetAbortUpload.Warning")}
            </Alert>
            <Grid container sx={{padding: theme.spacing(2, 1, 0, 0),}}>
                <Button variant="contained" color="primary" component="span"
                        onClick={props.handleAbort}
                        size="large"
                        sx={{mr: 1}}
                >
                    {t("common.Agree")}
                </Button>
                <Button variant="contained" color="primary" component="span"
                        size="large"

                        onClick={props.handleBack}
                        sx={{mr: 1}}
                >
                    {t("common.Disagree")}
                </Button>
            </Grid>
        </Grid>
    );
}
